import { CommonModule } from 'src/common/common.module';
import { MenuConfiguration, Store } from 'src/common/models';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { ChangeDetectionStrategy, Component, computed, input, } from '@angular/core';

@Component({
  selector: 'app-store-hours-of-operation',
  templateUrl: './store-hours-of-operation.component.html',
  styleUrls: ['./store-hours-of-operation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]

})
export class StoreHoursOfOperationComponent {
  store = input<Store>()
  _store = computed<Store|undefined>(() => {
    let inputStore = this.store();
    let configStore = ContentCacheUtils.menu<MenuConfiguration>()?.store;
    return inputStore ?? configStore;
  })
  menu?: Partial<MenuConfiguration> | null = ContentCacheUtils.menu<MenuConfiguration>();

}
